/* eslint-disable id-length */
import { isHexColor } from './isHexColor.js';

export const hexToVec3 = (hex: string): [number, number, number] => {
  if (isHexColor(hex) === false) {
    throw new Error(`Invalid hex color: ${hex}`);
  }

  const r = Number.parseInt(hex.slice(1, 3), 16) / 255;
  const g = Number.parseInt(hex.slice(3, 5), 16) / 255;
  const b = Number.parseInt(hex.slice(5, 7), 16) / 255;
  return [r, g, b];
};
